<template>
  <div class="width-100 mainBox flex-column justify-content-start align-items-center" style="min-width: 1200px">
    <!--    顶部菜单栏-->
    <tab class="fixed" select="4" style="min-width: 1200px"></tab>

    <img src="@/assets/image/banner8.jpg" width="100%" alt="" />
    <div class="main margin-b flex-row justify-content-spaceBetween align-items-center margin-ts border-b">
      <p class="fs-mid grey margin-bs">当前位置：首页 > 法律声明</p>
    </div>
    <div class="main flex-column justify-content-start align-items-star">暂无内容。。。</div>
    <!--    <backBtn></backBtn>-->

    <footerBox class="margin-t" style="position: fixed; bottom: 0"></footerBox>
  </div>
</template>
<script>
import tab from '@/components/tab.vue';
import footerBox from '@/components/footer.vue';

export default {
  name: 'law',
  components: {
    tab,
    footerBox
  },
  data() {
    return {};
  },
  mounted() {},

  created() {},
  methods: {
    jumpTo(e, param) {
      let text = this.$router.resolve({ path: e, query: { param: param } });
      // 打开一个新的页面
      window.open(text.href, '_blank');
    }
  }
};
</script>

<style lang="less" scoped>
.titBox {
  border-left: 4px solid rgb(11, 73, 158) !important;
  width: 98%;
  padding-left: 1%;
}
.fixed {
  position: fixed;
  top: 0;
  z-index: 99;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.05);
}
.mainBox {
  height: 200px;
  padding-top: 60px;
}
.search {
  border: none !important;
}
.searchBox {
  padding: 4px 10px;
  border-radius: 5px;
}

.border-b {
  border-bottom: 1px solid #eeeeee;
}
.padding-b {
  padding-bottom: 20px;
}
.box {
  max-height: 140px;
  padding: 20px 3%;
  width: 94%;
}
.label {
  width: 140px;
}
</style>
<style>
.van-pagination__item--active {
  background-color: rgb(11, 73, 158) !important;
  color: #ffffff !important;
}
.van-pagination__item {
  min-width: 30px;
  height: 30px;
  margin: 0 3px;
  border: 1px solid #eeeeee;
  color: #666666;
}
</style>
